/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { Button, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Heading4 } from '../../../../Components/FormHeading';
import SearchBox from '../../../../Components/SearchBox';
import { handleEventCoursesUpdate } from '../../../../Redux/slices/event';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import { debounce, ErrorMessageHandler } from '../../../../_helpers/_methods';
import CourseView from '../Steps/components/CourseView/_CourseView';

// eslint-disable-next-line no-undef
const KMS_API = process.env.REACT_APP_KMS;

function Courses() {
  const dispatch = useDispatch();
  const local = useSelector((state) => state.local.local);
  const courses = useSelector((state) => state.event?.event?.course_links);
  const thematicAreas = useSelector((state) => state.event?.event?.thematic_areas);
  const [selectedThematicAreas, setSelectedThematicAreas] = useState([]);
  const activeRole = useSelector((state) => state.user?.user?.active_role);
  const { id } = useParams();
  const completed = useSelector((state) => state.event.event.completed);

  const updateNewCourses = async (newCourses) => {
    try {
      const response = await fetchWrapper.patch(`/event/${id}/`, {
        course_links: newCourses
      });
      dispatch(handleEventCoursesUpdate(newCourses));
      toast.success('Course Links Updated Successfully');
    } catch (error) {
      console.log(error);
      ErrorMessageHandler(error);
    }
  };
  return (
    <div className="card">
      <div className="card-body">
        <div className="col-12">
          <div>
            <CourseView
              selectedCourses={courses}
              updateCourseLinks={updateNewCourses}
              canAddCourse={
                !completed &&
                ['superuser', 'cd_admin', 'executive', 'resource_person'].includes(activeRole)
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Courses;
